import { Box, Stack } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib";
import { Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { BottomSheetHeader } from "../components/BottomSheetHeader";
import { Button } from "../components/Button";
import { DialogFooter } from "../components/DialogFooter";

interface NursesWeekNominationBottomSheetProps {
  modalState: UseModalState;
  onNominateClick: () => void;
}

export function NursesWeekNominationBottomSheet(props: NursesWeekNominationBottomSheetProps) {
  const { modalState, onNominateClick } = props;

  return (
    <FullScreenDialog
      modalState={modalState}
      variant="tertiary"
      PaperProps={{
        sx: (theme) => ({
          backgroundColor: theme.palette.background.tertiary,
          overflow: "hidden",
        }),
      }}
    >
      <BottomSheetHeader
        onClose={() => {
          modalState.closeModal();
        }}
      />

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        <Stack
          spacing={7}
          sx={{
            paddingTop: 8,
            paddingX: 7,
            textAlign: "center",
          }}
        >
          <Text variant="h3" textAlign="center">
            OFF THE CHARTS
          </Text>

          <Text variant="h5" textAlign="center" color={(theme) => theme.palette.text.secondary}>
            Moments that Matter
          </Text>

          <Text variant="body1" textAlign="center" color={(theme) => theme.palette.text.secondary}>
            Know a nurse whose expertise, judgment, and heart go beyond the ordinary? Nominate them
            for Nurses Week and they could win special recognition from Clipboard.
          </Text>

          <Stack spacing={3}>
            <Text variant="body2" textAlign="center" color={(theme) => theme.palette.text.tertiary}>
              🏆 Special appreciation from our team
            </Text>
            <Text variant="body2" textAlign="center" color={(theme) => theme.palette.text.tertiary}>
              🎁 An exclusive experience or gift
            </Text>
            <Text variant="body2" textAlign="center" color={(theme) => theme.palette.text.tertiary}>
              ⭐ A spotlight on our App and Social Media
            </Text>
          </Stack>
        </Stack>
      </Box>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onNominateClick}>
          Nominate a Nurse
        </Button>
      </DialogFooter>
    </FullScreenDialog>
  );
}
